import EverTrue from "app";
import Pusher from "pusher-js";

export default new Pusher(EverTrue.config.pusher_key);
